import { MerchantPrivilege, MerchantProfile } from '@/types/Merchant';

export const isTrustedMerchant = (merchant?: MerchantProfile): boolean => {
  return merchant?.privilege !== MerchantPrivilege.STANDARD;
};
